export default __webpack_public_path__ + "static/media/bizmandala.5ca85a23.png";